import http from '../plugins/axios';

const BASE_PATH = '/api/company/v3/payment'

const downloadPayments = async (params = {}) => {
  const response = await http.get(`${BASE_PATH}/download`, { params,  responseType: 'blob' });
  return response.data;
};

const loadObjectsForPayments = async (params = {}) => {
  const response = await http.get(`${BASE_PATH}/rooms`, { params });
  return response.data;
};

export {
  downloadPayments,
  loadObjectsForPayments
};
